"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Read = void 0;
var tslib_1 = require("tslib");
var Read_1 = require("@reactionable/core/lib/crud/read/Read");
var react_1 = tslib_1.__importDefault(require("react"));
var Col_1 = tslib_1.__importDefault(require("react-bootstrap/Col"));
var Container_1 = tslib_1.__importDefault(require("react-bootstrap/Container"));
var Row_1 = tslib_1.__importDefault(require("react-bootstrap/Row"));
function Read(_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement(Read_1.Read, tslib_1.__assign({}, props, { children: function (data) { return (react_1.default.createElement(Container_1.default, { fluid: true },
            react_1.default.createElement(Row_1.default, null,
                react_1.default.createElement(Col_1.default, null, children(data))))); } })));
}
exports.Read = Read;
//# sourceMappingURL=Read.js.map